import { Component, computed, input } from '@angular/core';
import { OrganisationAddress } from 'app/shared/models/organisation.model';

/** Button with Popover that contains Organisation Contact Information.
 *
 * Please provide also the following css variable for correct styling:
 * - contact-button-font-family: sets the text font family
 * - contact-button-color: sets the text color
 */
@Component({
  selector: 'ez-contact',
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  readonly mainLogoUrl = input.required<string>();
  readonly companyName = input.required<string>();
  readonly companyAddress = input.required<OrganisationAddress>();
  readonly smallLogoUrl = input<string>();
  readonly companyPhone = input<string>();
  readonly companyEmail = input<string>();
  readonly companyWeb = input<string>();

  readonly altText = computed(() => `Firmenlogo ${this.companyName()}`);

  showPopupPanel = false;

  togglePopup() {
    this.showPopupPanel = !this.showPopupPanel;
  }
}
